import { Box } from '@mui/material'
import { ReactComponent as HealthLogo } from 'assets/icons/health-logo.svg'
import { getTranslationStatus } from 'components/cattles/lamenessPage/shared/processes'
import { InspectionStatus, TreatmentStatus } from 'models'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import InfoChipItem from 'ui/InfoChipItem'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

const LamenessWidjet = props => {
	const { lameness, lastMilking, treatmentStatus } = props
	const isNoDataValue = (value: unknown) =>
		value == null ||
		(typeof value === 'string' &&
			(value.trim() === '' || value.trim().toLowerCase() === 'нет данных'))
	const hasLameness = !isNoDataValue(lameness)
	const hasLastMilking = !isNoDataValue(lastMilking)
	const isScoreHigh = hasLameness && Number(lameness) > 1

	const isError =
		treatmentStatus === InspectionStatus.Required ||
		treatmentStatus === InspectionStatus.Expired
	const isTreatment = treatmentStatus === TreatmentStatus.Treated
	const translateStatus = getTranslationStatus(treatmentStatus)
	const iconColor = isTreatment
		? COLORS.health
		: isScoreHigh || isError
			? COLORS.error
			: COLORS.secondary

	return (
		<CardStandart
			sx={{
				width: '100%',
				padding: '24px',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
			}}
		>
			<Box display={'flex'} flexDirection={'row'} gap={'8px'} mr={'4px'}>
				<span>
					<HealthLogo fill={iconColor} stroke={iconColor} />
				</span>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',
						gap: '8px',
					}}
				>
					{hasLameness ? (
						<TypographyPrimary16Bold
							sx={{
								color: isScoreHigh ? COLORS.error : COLORS.black,
							}}
						>
							{lameness}{' '}
							<span
								style={{
									color: COLORS.secondary,
									fontWeight: 400,
									fontSize: '12px',
								}}
							>
								балла
							</span>
						</TypographyPrimary16Bold>
					) : (
						<TypographySecondary>Нет данных</TypographySecondary>
					)}
					<TypographySecondary>Хромота</TypographySecondary>
				</Box>
			</Box>
			<Box
				display={'flex'}
				flexDirection={'column'}
				justifyContent={isError || isTreatment ? 'space-between' : 'flex-end'}
				gap={'8px'}
			>
				{isError && treatmentStatus && (
					<InfoChipItem
						bgColor={isTreatment ? COLORS.healthOpacity10 : COLORS.error10}
						label={translateStatus}
						labelColor={isTreatment ? COLORS.health : COLORS.error}
					/>
				)}

				{hasLastMilking && (
					<TypographySecondary alignSelf={'flex-end'}>
						{`замер ${moment(lastMilking).format('D.MM.YY')}`}
					</TypographySecondary>
				)}
			</Box>
		</CardStandart>
	)
}

export default LamenessWidjet
